import { Component, Inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TeltonikaLogTableData } from '@huge-monorepo/shared/interfaces';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { Observable } from 'rxjs';
import { SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService, ICustomerTeltonikaService } from '@huge-monorepo/shared/interfaces';

@Component({
  selector: 'huge-monorepo-teltonika-display-logs-modal',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './TeltonikaDisplayLogsModal.component.html',
  styleUrl: './TeltonikaDisplayLogsModal.component.scss',
})
export class TeltonikaDisplayLogsModalComponent {
  teltonikaService = this.sharedTeltonikaService.getService();
  fetchedData?: TeltonikaLogTableData;
  loading: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<TeltonikaDisplayLogsModalComponent>,
    @Inject(MAT_DIALOG_DATA) data: TeltonikaLogsModalInput,
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
  ) {
    this.fetchedData = data.tableConfig;
    if (data.dataRequest != null) {
      this.fetchLogs(data.dataRequest);
    } else {
      this.loading = false;
    }
  }

  fetchLogs(request: Observable<any>): void {
    request.subscribe({
      next: (data) => {
        if (data == null) {
          this.loading = false;
          return;
        }
        if(this.fetchedData){
          this.fetchedData.rows = data;
        }
        this.loading = false;
      },
      error: (error) => {
        console.error(error);
      }
    });
    // this.teltonikaService.getDeviceLogs(data.deviceID, data.Types, 500).subscribe({
    //   next: (data) => {
    //     if (data == null) {
    //       this.loading = false;
    //       return;
    //     }
    //     this.fetchedData = {
    //       headers: ["Log", "User", "Type", "Date"], rows: data
    //     };
    //     this.loading = false;
    //   },
    //   error: (error) => {
    //     console.error(error);
    //   }
    // })
  }


  close(): void {
    if (this.fetchedData && this.fetchedData.overwriteText) {
      this.fetchedData.overwriteText = undefined;
      return;
    }

    this.dialogRef.close();
  }
}

type TeltonikaLogsModalInput = {
  dataRequest: Observable<any>;
  tableConfig: TeltonikaLogTableData;
}
